<div class="flex flex-col items-center w-full">
    <a routerLink="/" class="flex flex-row" [ngClass]="{'justify-center': center}">
        <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        class="h-14 w-14"
        width="33"
        height="32"
        fill="none"
        style="enable-background:new 0 0 512 512;">
            <style type="text/css">
                .st0{fill:#ffffff;}
                .st1{fill:var(--color-brand-blue);}
                .st2{fill:var(--color-brand-green);}
            </style>
            <g>
                <path class="st1" d="
                    M80,0
                    h214
                    v376
                    h-296
                    v-296 a80,80 0 0 1 80,-80
                    z"
                />

                <path class="st0" d="
                    M295,0
                    h38
                    v412
                    h-335
                    v-38
                    h295
                    v-432
                    z"
                />

                <path class="st2" d="
                    M332,0
                    h100 a80,80 0 0 1 80,80
                    v352 a80,80 0 0 1 -80,80
                    h-352 a80,80 0 0 1 -80,-80
                    v-20
                    h332
                    v-432
                    z"
                />
            </g>
        </svg>
    </a>

    <div class="flex flex-col items-center gap-2 w-full">
        @if (title) {
            <a routerLink="/" class="mt-4 text-surface-900 dark:text-surface-0 text-2xl font-semibold leading-tight text-center w-full no-underline text-inherit">{{title}}</a>
        }

        <div class="text-center w-full">
            <ng-content></ng-content>
        </div>
    </div>
</div>
